import { Drawer, DrawerProps } from "@mui/material"
import { ReactNode } from "react"

type Props = {
    children: ReactNode
} & DrawerProps

const BottomSheet = ({ children, ...props }: Props) => {
    return (
        <Drawer
            anchor="bottom"
            PaperProps={{
                sx: {
                    borderRadius: "16px 16px 0 0",
                },
            }}
            {...props}
        >
            {children}
        </Drawer>
    )
}

export default BottomSheet
